export class ApiError extends Error {
  public code: string;
  public statusCode: number;

  constructor(message: string, statusCode: number, code: string) {
    super(message);
    this.statusCode = statusCode;
    this.code = code;
  }
}
